'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var CATEGORIES = 'M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z';
var IconCategories = lib.variant('IconCategories', icon.Icon, {
    path: CATEGORIES,
});

exports.IconCategories = IconCategories;
//# sourceMappingURL=index-8424dd41.js.map
